export default __webpack_public_path__ + "static/media/imageTum3.55b3986c.jpg";